import SelectWidget from '../Widgets/SelectWidget'
import MultiselectWidget from '../Widgets/MultiselectWidget'
// import CheckboxWidget from '../Widgets/CheckboxWidget'
// import DatePickerWidget from '../Widgets/DatePickerWidget'
// import DateRangeWidget from '../Widgets/DateRangeWidget'
// import SliderWidget from '../Widgets/SliderWidget'
// import CombinedInputWidget from '../Widgets/CombinedInputWidget'
// import AutocompleteMultiselectWidget from '../Widgets/AutocompleteMultiselectWidget'
// import InputWidget from '../Widgets/InputWidget'
import SearchWidget from '../Widgets/SearchWidget'
import RangeWidget from '../Widgets/RangeWidget'
// import ChipsWidget from '../Widgets/ChipsWidget'
// import BooleanWidget from '../Widgets/BooleanWidget'
// import LocationWidget from '../Widgets/LocationWidget'

const WIDGETS_MAP = {
  SearchFilter: SearchWidget,
  ChoiceFilter: SelectWidget,
  MultipleChoiceFilter: MultiselectWidget,
  NumberFilter: RangeWidget,
}

export default {
  widgetsMap: WIDGETS_MAP,

  computed: {
    parameters() {
      return {
        disabled: this.disabled,
        values: this.value,
      }
    },
  },

  methods: {
    getPriceValue(key) {
      const objKeys = {
        min: this.value[`${key}_min_${this.getCurrencyValue()}`],
        max: this.value[`${key}_max_${this.getCurrencyValue()}`],
      }
      if (objKeys.min && objKeys.max) {
        return objKeys
      }
      return null
    },

    getCurrencyValue() {
      const priceKeys = ['price_max_', 'price_min_']
      let currencyVal = null
      Object.keys(this.value).forEach(key => {
        if (priceKeys.some(el => key.startsWith(el))) {
          const currency = key.split('_')[2]
          currencyVal = currency
        }
      })
      return currencyVal
    },

    getMultiValue(key) {
      const miltipleKeys = ['area']
      const priceKey = 'price'
      if (miltipleKeys.includes(key)) {
        return {
          min: this.value[`${key}_min`],
          max: this.value[`${key}_max`],
        }
      } if (key === priceKey) {
        return this.getPriceValue(key)
      }
      return this.value[key]
    },

    updateMultipleValues(key, values) {
      console.log(key)
      const value = {
        min_storage: 0,
        max_storage: 0,
      }
      /* eslint-disable prefer-destructuring */
      if (values[0] < values[1]) {
        value.min_storage = values[0]
        value.max_storage = values[1]
      } else if (values[0] < values[1]) {
        value.min_storage = values[0]
        value.max_storage = values[0]
      } else {
        value.min_storage = values[1]
        value.max_storage = values[0]
      }
      // coasnmasd
      // console.log(value)
      // this.$emit('input', value)
      // let res = {}
      // Object.keys(values).forEach(k => {
      //   res = { ...res, [`${key}_${k}`]: values[k] }
      // })
      this.$emit('input', Object.assign(this.value, value))
    },

    onlyValue(key, value) {
      this.$emit('input', { [key]: value })
    },

    updateValue(key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
  },
}
